<template>
    <div class="box" ref="prize">
        <div>
            <div class="top">
                <img class="prize" src="http://source.weicistudy.com/draw/prize.png" alt="">
                <img class="l-fire fire" src="http://source.weicistudy.com/draw/left-fireworks.png" alt="">
                <img class="r-fire fire" src="http://source.weicistudy.com/draw/right-fireworks.png" alt="">
                <img class="t-fire fire" src="http://source.weicistudy.com/draw/left-fireworks.png" alt="">
                <!--<img class="b-fire fire" src="../../assets/images/right-fireworks.png" alt="">-->
            </div>
            <p class="tit">
                <span style="font-size: 23px;display: inline-block;margin-bottom: 5px">恭喜您，中奖啦！</span><br>获得Apple iPhone XS 64GB 手机一部<br>工作人员会在2月20日后与您取得联系
            </p>
            <div class="intr">
                <a href="javascript:;" class="introduction activity" @click="intrShow">
                    <img src="http://source.weicistudy.com/draw/js_button.png" alt="">
                    <span class="titName">活动介绍</span>
                </a>
                <a href="javascript:;" class="rule activity" @click="ruleShow">
                    <img src="http://source.weicistudy.com/draw/rule_button.png" alt="">
                    <span class="titName">活动规则</span>
                </a>
            </div>
            <p class="arrow">
                <img src="http://source.weicistudy.com/draw/arrow.png" alt="">
            </p>
            <!--<winner-list :stage="stage"></winner-list>-->
            <!--<winner-list imgPosition="bottom"></winner-list>-->
            <template v-if="stage === 'second' && twoList.length">
                <winner-list :stage="stage" :winnerList='twoList'></winner-list>
                <winner-list imgPosition="bottom" :winnerList='oneList' v-if="oneList.length"></winner-list>
            </template>
            <template v-else>
                <winner-list :winnerList='oneList' v-if="oneList.length"></winner-list>
            </template>
            <img class="tips" src="http://source.weicistudy.com/draw/tips.png" alt="">
        </div>
        <activity-introduction v-show="intrFlag" @close="intrHide"></activity-introduction>
        <activity-rules v-show="ruleFlag" @close="ruleHide" :stage="stage"></activity-rules>
    </div>
</template>

<script>
    /*中奖结果展示页面*/
    import WinnerList from '@/components/lottery/WinnerList'
    import ActivityIntroduction from '@/components/lottery/ActivityIntroduction'
    import ActivityRules from '@/components/lottery/ActivityRules'
    import LotteryService from '@/service/LotteryService'
    export default {
        name: "WinPrize",
        components: {
            WinnerList, ActivityIntroduction, ActivityRules
        },
        data () {
            return {
                userCode: '',
                session: '',
                appId: 0,
                bannerId: 0,
                // status: 0,
                // signUp: 0,
                // activityBatch: 0,
                stage: 'second', // 当前阶段
                intrFlag: false, // 活动说明隐藏显示标志
                ruleFlag: false, // 活动规则隐藏显示标志
                oneList: [], // 第一波获奖名单
                twoList: [], // 第二波获奖名单
                isHasData: false // 获奖名单数据是否得到
            }
        },
        created () {
            this.userCode = this.$route.query.user_code;
            this.session = this.$route.query.session;
            this.appId = this.$route.query.app_id;
            this.bannerId = this.$route.query.banner_id
            this.stage = this.$route.query.stage
            // this.init()
            this.initWinnerList();
        },
        methods: {
            // init () {
            //     let _this = this;
            //     LotteryService.getInfo(this.userCode,this.session,this.appId,this.bannerId)
            //         .then(res => {
            //             if (res.data.result_code === 200) {
            //                 _this.status = res.data.info.activity_status;
            //                 _this.signUp = res.data.info.sign_up
            //                 _this.activityBatch = res.data.info.activity_batch
            //             }
            //         })
            //         .catch(error => {
            //             console.log(error)
            //         })
            // },
            initWinnerList () {
                let _this = this
                LotteryService.list(_this.userCode, _this.session, _this.appId, _this.bannerId)
                    .then(res => {
                        if (res.data.result_code === 200) {
                            _this.oneList = res.data.one_list
                            _this.twoList = res.data.two_list
                            _this.isHasData = true
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }, // 获取获奖名单
            intrHide () {
                this.intrFlag = false
            }, // 活动说明隐藏
            intrShow () {
                this.intrFlag = true
            }, // 活动说明显示
            ruleHide () {
                this.ruleFlag = false
            }, // 活动规则隐藏
            ruleShow () {
                this.ruleFlag = true
            } // 活动规则显示
        },
        computed: {
            dataList () {
                return this.stage === 'second' ?  this.twoList : this.oneList
            }
            // stage () {
            //     if (this.status=== 3 || this.status=== 4 || this.status=== 5 || this.status=== 6) {
            //         return 'first'
            //     } else {
            //         return 'second'
            //     }
            // }
        }
        // watch: {
        //     intrFlag () {
        //         if (this.intrFlag) {
        //             document.documentElement.style.overflow = 'hidden'
        //         } else {
        //             document.documentElement.style.overflow = 'scroll'
        //         }
        //     }, // 防止滑动上面页面时下面的页面跟着滚动(说明)
        //     ruleFlag () {
        //         if (this.ruleFlag) {
        //             document.documentElement.style.overflow = 'hidden'
        //         } else {
        //             document.documentElement.style.overflow = 'scroll'
        //         }
        //     } // 防止滑动上面页面时下面的页面跟着滚动（规则）
        // }
        // mounted () {
        //     this.refs.prize.scrollTop = 0
        // }
    }
</script>

<style scoped>
    @keyframes l-blooming {
        0%{
            transform: scale(0);  /*开始为原始大小*/
        }
        5%{
            transform: scale(0.015); /*放大1.1倍*/
        }
        10%{
            transform: scale(0.030); /*放大1.1倍*/
        }
        15%{
            transform: scale(0.045); /*放大1.1倍*/
        }
        20%{
            transform: scale(0.060); /*放大1.1倍*/
        }
        25%{
            transform: scale(0.075); /*放大1.1倍*/
        }
        30%{
            transform: scale(0.090); /*放大1.1倍*/
        }
        35%{
            transform: scale(0.105); /*放大1.1倍*/
        }
        40%{
            transform: scale(0.120); /*放大1.1倍*/
        }
        45%{
            transform: scale(0.135); /*放大1.1倍*/
        }
        50%{
            transform: scale(0.150);
        }
        55%{
            transform: scale(0.165); /*放大1.1倍*/
        }
        60%{
            transform: scale(0.180); /*放大1.1倍*/
        }
        65%{
            transform: scale(0.195); /*放大1.1倍*/
        }
        70%{
            transform: scale(0.210); /*放大1.1倍*/
        }
        75%{
            transform: scale(0.225);
        }
        80%{
            transform: scale(0.240); /*放大1.1倍*/
        }
        85%{
            transform: scale(0.255); /*放大1.1倍*/
        }
        90%{
            transform: scale(0.270); /*放大1.1倍*/
        }
        95%{
            transform: scale(0.285); /*放大1.1倍*/
        }
        100%{
            transform: scale(0.3);
        }

    }
    @keyframes r-blooming {
        0%{
            transform: scale(0);  /*开始为原始大小*/
        }
        5%{
            transform: scale(0.01); /*放大1.1倍*/
        }
        10%{
            transform: scale(0.02); /*放大1.1倍*/
        }
        15%{
            transform: scale(0.03); /*放大1.1倍*/
        }
        20%{
            transform: scale(0.04); /*放大1.1倍*/
        }
        25%{
            transform: scale(0.05); /*放大1.1倍*/
        }
        30%{
            transform: scale(0.06); /*放大1.1倍*/
        }
        35%{
            transform: scale(0.07); /*放大1.1倍*/
        }
        40%{
            transform: scale(0.08); /*放大1.1倍*/
        }
        45%{
            transform: scale(0.09); /*放大1.1倍*/
        }
        50%{
            transform: scale(0.10);
        }
        55%{
            transform: scale(0.11); /*放大1.1倍*/
        }
        60%{
            transform: scale(0.12); /*放大1.1倍*/
        }
        65%{
            transform: scale(0.13); /*放大1.1倍*/
        }
        70%{
            transform: scale(0.14); /*放大1.1倍*/
        }
        75%{
            transform: scale(0.15);
        }
        80%{
            transform: scale(0.16); /*放大1.1倍*/
        }
        85%{
            transform: scale(0.17); /*放大1.1倍*/
        }
        90%{
            transform: scale(0.18); /*放大1.1倍*/
        }
        95%{
            transform: scale(0.19); /*放大1.1倍*/
        }
        100%{
            transform: scale(0.20);
        }

    }
    .box {
        background-color: #FD7759;
        /*position: fixed;*/
        /*top:0;*/
        /*left: 0;*/
        /*width: 100vw;*/
        /*height: 100vh;*/
        /*overflow: auto;*/
    }
    .top {
        position: relative;
        width: 100%;
    }
    .top .prize {
        width: 100%;
    }
    .top .fire {
        position: absolute;
        /*animation: l-blooming 1.3s infinite;*/
    }
    .top .l-fire {
        left:-122px;
        bottom:-166px;
        animation: l-blooming 1.3s infinite;
    }
    .top .r-fire {
        right:-68px;
        bottom:165px;
        animation: l-blooming 1.3s infinite;
    }
    /*.top .b-fire {*/
        /*left:-128px;*/
        /*bottom: 225px;*/
        /*animation: r-blooming 1.3s infinite;*/
    /*}*/
    .top .t-fire {
        left:68px;
        bottom:250px;
        animation: r-blooming 1.3s infinite;
    }
    .tit {
        margin: 35px 0 41px;
        padding:0 80px;
        text-align: center;
        font-size:34px;
        font-weight:400;
        line-height: 60px;
        color:rgba(255,255,255,1);
        width: 100%;
        box-sizing: border-box;
    }
    .intr {
        width: 100%;
        text-align: center;
    }
    .activity {
        position: relative;
        display: inline-block;
        width:166px;
        height:60px;
        /*!*z-index: 1000;*!*/
        /*line-height: 65px;*/
        /*font-size:27px;*/
    }
    .activity .titName {
        position: absolute;
        left:0;
        top: 0;
        width:166px;
        height:60px;
        /*z-index: 1000;*/
        line-height: 60px;
        font-size:26px;
        font-weight:400;
        color:rgba(255,255,255,1);
    }
    .activity img {
        width: 100%;
        height: 100%;
    }
    .introduction {
        margin-right:73px;
    }
    .arrow {
        width: 100%;
        text-align: center;
        margin: 40px 0 30px
    }
    .arrow img {
        width: 32px;
    }
    .tips {
        width: 464px;
        margin: 25px 0 36px 40px;
    }
</style>